export const createNewOrder = () => {
	return({type: 'CREATE_NEW_ORDER'});
};

export const addOrderLine = (lines, total) => {
	return({type: 'ADD_ORDER_LINE', newLines: lines, newTotal: total});
};

export const modifyOrderLine = (newLines, newTotal) => {
    return({type: 'MODIFY_ORDER_LINE', newLines: newLines, newTotal: newTotal});
};

export const removeOrderLine = (newLines, newTotal) => {
    return({type: 'REMOVE_ORDER_LINE', newLines: newLines, newTotal: newTotal});
};

export const clearOrder = () => {
    return({type: 'CLEAR_ORDER'});
};






// WEBPACK FOOTER //
// ./src/actions/orderActions.js